import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground border-border",
        // Status variants (pill-shaped with background, for use with dot indicator)
        open: "border-transparent bg-status-open-bg text-status-open-fg",
        review: "border-transparent bg-status-review-bg text-status-review-fg",
        planned: "border-transparent bg-status-planned-bg text-status-planned-fg",
        progress: "border-transparent bg-status-progress-bg text-status-progress-fg",
        complete: "border-transparent bg-status-complete-bg text-status-complete-fg",
        closed: "border-transparent bg-status-closed-bg text-status-closed-fg",
        // Status text variants (no background, colored text only - Canny style)
        "status-text-open": "border-transparent bg-transparent text-status-open-fg uppercase tracking-wide font-semibold px-0",
        "status-text-review": "border-transparent bg-transparent text-status-review-fg uppercase tracking-wide font-semibold px-0",
        "status-text-planned": "border-transparent bg-transparent text-status-planned-fg uppercase tracking-wide font-semibold px-0",
        "status-text-progress": "border-transparent bg-transparent text-status-progress-fg uppercase tracking-wide font-semibold px-0",
        "status-text-complete": "border-transparent bg-transparent text-status-complete-fg uppercase tracking-wide font-semibold px-0",
        "status-text-closed": "border-transparent bg-transparent text-status-closed-fg uppercase tracking-wide font-semibold px-0",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
